import { __spreadArray, __read } from '../../node_modules/tslib/tslib.es6.esm.js';
import { useContext } from 'react';
import { NvTagsContext } from './NvTagsContextProvider.esm.js';

var useTags = function () {
    var _a = useContext(NvTagsContext), checkedOptions = _a.checkedOptions, setCheckedOptions = _a.setCheckedOptions, closeModal = _a.closeModal, openModal = _a.openModal, tags = _a.tags, setTags = _a.setTags, onFinish = _a.onFinish;
    var handleCheckOption = function (option, checked) {
        if (checked) {
            setCheckedOptions(function (prevValue) { return __spreadArray(__spreadArray([], __read(prevValue.filter(function (prev) { return prev.id !== option.id; })), false), [option], false); });
        }
        else {
            setCheckedOptions(function (prevValue) { return prevValue.filter(function (prev) { return prev.id !== option.id; }); });
        }
    };
    var handleFinish = function () {
        setTags(checkedOptions);
        closeModal();
        onFinish === null || onFinish === void 0 ? void 0 : onFinish(checkedOptions);
    };
    var removeTag = function (tagId) {
        var newTags = tags.filter(function (tag) { return tag.id !== tagId; });
        setTags(newTags);
        setCheckedOptions(newTags);
        onFinish === null || onFinish === void 0 ? void 0 : onFinish(newTags);
    };
    var removeAllTags = function () {
        setTags([]);
        setCheckedOptions([]);
        onFinish === null || onFinish === void 0 ? void 0 : onFinish([]);
    };
    return {
        checkedOptions: checkedOptions,
        closeModal: closeModal,
        handleCheckOption: handleCheckOption,
        handleFinish: handleFinish,
        openModal: openModal,
        removeAllTags: removeAllTags,
        removeTag: removeTag,
        tags: tags,
    };
};

export { useTags };
//# sourceMappingURL=useTags.esm.js.map
